export default (value, { length }) => {
  const valueLength = String(value).length;
  return valueLength === 0 ? true : valueLength >= length;
};



// WEBPACK FOOTER //
// ./src/utils/validations/minLengthValidator.js